module.exports = __webpack_public_path__ + "media/flags/gb-eng-67715a32.svg";